<template>
  <v-form
    ref="taxiForm"
    v-model="valid"
    class="compact-form"
  >
    <v-layout
      style="width: 100%"
      wrap
    >
      <v-flex
        xs12
        pl-2
      >
        <v-layout
          class="field-padding"
          wrap
        >
          <v-flex
            xs6
            md3
            px-2
          >
            <label class="cmr-label-text">Plate Number (*)</label>
            <v-text-field
              v-model="taxi.plate_number"
              :error-messages="errorForField('plate_number')"
              :rules="taxiRules.plate_number"
              maxlength="6"
              required
              dense
              outlined
              :disabled="disabled"
              @input="resetError('plate_number')"
            />
          </v-flex>
          <v-flex
            xs6
            md3
            px-2
          >
            <label class="cmr-label-text">Registration Number (*)</label>
            <v-text-field
              v-model="taxi.registration_number"
              :error-messages="errorForField('registration_number')"
              maxlength="8"
              dense
              outlined
              :rules="taxiRules.registration_number"
              :disabled="disabled"
              @input="resetError('registration_number')"
            />
          </v-flex>
          <v-flex
            xs6
            md3
            px-2
          >
            <label class="cmr-label-text">Make (*)</label>
            <v-text-field
              v-model="taxi.make"
              :error-messages="errorForField('make')"
              maxlength="20"
              :rules="taxiRules.make"
              dense
              outlined
              :disabled="disabled"
              @input="resetError('make')"
            />
          </v-flex>
          <v-flex
            xs6
            md3
            px-2
          >
            <label class="cmr-label-text">Model (*)</label>
            <v-text-field
              v-model="taxi.model"
              :error-messages="errorForField('model')"
              maxlength="20"
              :rules="taxiRules.model"
              dense
              outlined
              :disabled="disabled"
              @input="resetError('model')"
            />
          </v-flex>
          <v-flex
            xs6
            md3
            px-2
          >
            <label class="cmr-label-text">Colour (*)</label>
            <v-text-field
              v-model="taxi.colour"
              :error-messages="errorForField('colour')"
              maxlength="20"
              :rules="taxiRules.colour"
              dense
              outlined
              :disabled="disabled"
              @input="resetError('colour')"
            />
          </v-flex>
          <v-flex
            xs6
            md6
            px-2
          >
            <label class="cmr-label-text">Council (*)</label>
            <v-combobox
              v-model="taxi.council"
              :error-messages="errorForField('council')"
              :rules="taxiRules.council"
              :items="councils"
              dense
              outlined
              :disabled="disabled"
              @input="resetError('council')"
            />
          </v-flex>
          <v-flex
              xs6
              md6
              px-2
          >
            <label class="cmr-label-text">Euro Status (*)</label>
            <v-text-field
                v-model="taxi.euroStatus"
                :error-messages="errorForField('euroStatus')"
                maxlength="20"
                :rules="taxiRules.euroStatus"
                dense
                outlined
                :disabled="disabled"
                @input="resetError('euroStatus')"
            />
          </v-flex>
          <v-flex
              xs6
              md6
              px-2
          >
            <label class="cmr-label-text">Fuel Type (*)</label>
            <v-text-field
                v-model="taxi.fuelType"
                :error-messages="errorForField('fuelType')"
                maxlength="20"
                :rules="taxiRules.fuelType"
                dense
                outlined
                :disabled="disabled"
                @input="resetError('fuleType')"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        pt-2
        class="field-padding"
        xs12
        pl-2
      >
        <h4 class="grey--text text--darken-1">
          Capabilities
        </h4>
        <v-layout
          pt-2
          wrap
        >
          <v-flex
            md2
            px-2
            class="mr-2"
          >
            <v-btn-toggle
              class="pt-6"
              v-model="taxi.ppe_barrier"
              color="primary"
              :disabled="disabled"
              dense
            >
              <v-btn
                :value="true"
                text
                small
              >
                PPE Barrier
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          <v-flex
            xs6
            md3
            px-2
          >
            <label class="cmr-label-text">Number of Passengers (*)</label>
            <v-text-field
              v-model="taxi.num_seats"
              :error-messages="errorForField('num_seats')"
              :rules="taxiRules.num_seats"
              type="number"
              step="1"
              dense
              outlined
              :disabled="disabled"
              @input="resetError('num_seats')"
            />
          </v-flex>
          <v-flex
            xs6
            md3
            px-2
          >
            <label class="cmr-label-text">Ride Type (*)</label>
            <v-select
              v-model="taxi.ride_type_id"
              :error-messages="errorForField('ride_type_id')"
              :rules="taxiRules.ride_type_id"
              :items="rideTypes"
              item-text="name"
              item-value="id"
              dense
              outlined
              :disabled="disabled"
              @input="resetError('ride_type_id')"
              style="height: 32px !important;"
            />
          </v-flex>
          <v-flex
            xs6
            md3
            px-2
          >
            <label class="cmr-label-text">Body Type (*)</label>
            <v-select
              style="height: 32px !important;"
              v-model="taxi.type"
              :error-messages="errorForField('type')"
              :rules="taxiRules.type"
              :items="types"
              item-text="name"
              item-value="type"
              dense
              outlined
              :disabled="disabled"
              @input="resetError('type')"
            />
          </v-flex>
          <v-flex
          >
            <v-btn-toggle
                v-model="taxi.disabled_access"
                color="primary"
                :disabled="disabled"
                dense
            >
              <v-btn
                  :value="true"
                  text
                  small
              >
                Disabled Access
              </v-btn>
            </v-btn-toggle>

          </v-flex>
          <v-flex
          >
            <v-btn-toggle
                v-model="taxi.premium_vehicle"
                color="primary"
                :disabled="disabled"
                dense
            >
              <v-btn
                  :value="true"
                  text
                  small
              >
                Premium Vehicle
              </v-btn>
            </v-btn-toggle>
          </v-flex>

          <v-flex
          >
            <v-btn-toggle
                v-model="taxi.hackney_carriage"
                color="primary"
                :disabled="disabled"
                dense
            >
              <v-btn
                  :value="true"
                  text
                  small
              >
                Hackney Carriage
              </v-btn>
            </v-btn-toggle>

          </v-flex>
          <v-flex
          >
            <v-btn-toggle
                v-model="taxi.pets_allowed"
                color="primary"
                :disabled="disabled"
                dense
            >
              <v-btn
                  :value="true"
                  text
                  small
              >
                Pets
              </v-btn>
            </v-btn-toggle>

          </v-flex>
          <v-flex
            xs6
            md2
            px-2
          >
            <v-btn-toggle
                v-model="taxi.wide"
                color="primary"
                :disabled="disabled"
                dense
            >
              <v-btn
                  :value="true"
                  text
                  small
              >
                Wide Car
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex>
      </v-flex>
      <v-flex
        class="field-padding"
        xs12
        pl-2
      >
        <v-divider class="my-4"></v-divider>
  
        <h4 class="grey--text text--darken-1">
          Certificates
        </h4>
        <v-layout
          pt-2
          wrap
        >
          <v-flex
            xs6
            md3
            px-2
          >
            <label class="cmr-label-text">MOT Expiry Date</label>
            <DateInputIcon
              v-model="taxi.mot_valid_until"
              :error-messages="errorForField('mot_valid_until')"
              :rules="taxiRules.mot_valid_until"
              :disabled="disabled"
              @input="resetError('mot_valid_until')"
            />
          </v-flex>
          <v-flex
            xs6
            md3
            px-2
          >
            <label class="cmr-label-text">Road Tax Expiry Date</label>
            <DateInputIcon
              v-model="taxi.road_tax_valid_until"
              :error-messages="errorForField('road_tax_valid_until')"
              :rules="taxiRules.road_tax_valid_until"
              :disabled="disabled"
              @input="resetError('road_tax_valid_until')"
            />
          </v-flex>
          <v-flex
            xs6
            md5
            px-2
          >
            <label class="cmr-label-text">Council Compliance Certificate Expiry Date</label>
            <DateInputIcon
              v-model="taxi.compliance_certificate_expiry"
              :error-messages="errorForField('compliance_certificate_expiry')"
              :rules="taxiRules.compliance_certificate_expiry"
              :disabled="disabled"
              @input="resetError('compliance_certificate_expiry')"
            />
          </v-flex>
          <v-flex
            xs6
            md4
            px-2
          >
            <label class="cmr-label-text">Insurance Certificate Number</label>
            <v-text-field
              v-model="taxi.insurance_certificate_number"
              :error-messages="errorForField('insurance_certificate_number')"
              maxlength="50"
              :rules="taxiRules.insurance_certificate_number"
              dense
              outlined
              :disabled="disabled"
              @input="resetError('insurance_certificate_number')"
            />
          </v-flex>
          <v-flex
            xs6
            sm5
            md4
            px-2
          >
            <label class="cmr-label-text">Car Insurance Expiry</label>
            <DateInputIcon
              v-model="taxi.insurance_valid_until"
              :error-messages="errorForField('insurance_valid_until')"
              :rules="taxiRules.insurance_valid_until"
              :disabled="disabled"
              @input="resetError('insurance_valid_until')"
            />
          </v-flex>
          <v-flex
            xs6
            sm5
            md4
            px-2
          >
            <label class="cmr-label-text">Nominal Code</label>
            <v-text-field
              v-model="taxi.nominal_code"
              :error-messages="errorForField('nominal_code')"
              :rules="taxiRules.nominal_code"
              dense
              outlined
              :disabled="disabled"
              @input="resetError('nominal_code')"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import DateInputIcon from "@/components/widget/input/DateInputIconV2.vue";

export default {
  name: "TaxiFormV2",
  components: {
    DateInputIcon,
  },
  props: {
    taxi: Object,
    rideTypes: Array,
    councils: Array,
    errors: { type: Object, default: () => {} },
    disabled: Boolean,
  },
  data: function () {
    return {
      valid: false,
      taxiRules: {
        registration_number: [
          (v) => !!v || "Registration number is required",
          (v) =>
            (v && v.length <= 8) ||
            "Registration number cannot exceed 8 characters",
        ],
        plate_number: [
          (v) => !!v || "Plate number is required",
          (v) =>
            (v && v.length <= 6) || "Plate number cannot exceed 6 characters",
        ],
        make: [
          (v) => !!v || "Make is required",
          (v) => (v && v.length <= 20) || "Make cannot exceed 20 characters",
        ],
        model: [
          (v) => !!v || "Model is required",
          (v) => (v && v.length <= 20) || "Model cannot exceed 20 characters",
        ],
        colour: [
          (v) => !!v || "Colour is required",
          (v) => (v && v.length <= 20) || "Colour cannot exceed 20 characters",
        ],
        euroStatus: [
          (v) => !!v || "Euro Status is required",
          (v) => (v && v.length <= 20) || "Euro Status cannot exceed 20 characters",
        ],
        fuelType: [
          (v) => !!v || "Fuel Type is required",
          (v) => (v && v.length <= 20) || "Fuley Type cannot exceed 20 characters",
        ],
        num_seats: [(v) => !!v || "Number of seats is required"],
        type: [(v) => !!v || "Body type is required"],
        mot_valid_until: [
          (v) =>
            !v ||
            /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(v) ||
            "MOT expiry is in an invalid format",
        ],
        insurance_certificate_number: [],
        insurance_valid_until: [
          (v) =>
            !v ||
            /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(v) ||
            "Insurance expiry is in an invalid format",
        ],
        compliance_certificate_expiry: [
          (v) =>
            !v ||
            /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(v) ||
            "Compliance certificate expiry is in an invalid format",
        ],
        road_tax_valid_until: [
          (v) =>
            !v ||
            /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(v) ||
            "Road tax expiry is in an invalid format",
        ],
        council: [(v) => !!v || "Council is required"],
        ride_type_id: [(v) => !!v || "Ride type is required"],
      },
      types: [
        { name: "Saloon", type: "saloon" },
        { name: "Estate", type: "estate" },
        { name: "Mpv", type: "mpv" },
      ],
    };
  },
  watch: {
    disabled: function () {
      this.$refs.taxiForm.reset();
    },
    valid: function () {
      this.$emit("validityChange", this.valid);
    },
    'taxi.registration_number': function(newValue) {

      if(newValue && newValue.length >= 7) {
        this.$emit("taxiChanged", this.taxi.registration_number);
      }
    }
  },
  methods: {
    errorForField: function (field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function (field) {
      try {
        if (this.errors[field] != "") {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    validateForm: function () {
      this.$refs.taxiForm.validate();
    },
  },
};
</script>


<style >

.compact-form div.v-select__selections {
  height: 32px !important;
}

</style>
